import { motion } from 'framer-motion'
import styled from 'styled-components/macro'

import { mq } from 'styles/mq'
import { theme } from 'styles/theme'
import { IconShare } from 'components/icons/share2'
import Logo2Lines from './assets/Logotype_2lines.svg'
import { Container } from 'components/container'
import { Thread } from 'styles/misc'

export const Header = styled.div`
  position: relative;
  width: 100%;
  height: calc(100vh - var(--header-height));
  height: calc(100svh - var(--header-height));

  @media (orientation: portrait) {
    aspect-ratio: auto;
    overflow: hidden;
    height: calc(130vh - var(--header-height));
    height: calc(130svh - var(--header-height));
    margin-bottom: -30vh;
    margin-bottom: -30svh;
  }
`

export const HeaderInner = styled.div`
  position: relative;
  height: calc(100vh - var(--header-height));

  @media (orientation: portrait) {
    height: calc(100vh - var(--header-height));
    height: calc(100svh - var(--header-height));
  }
`

export const H1 = styled.h1`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  margin: 0;
  width: min-content;
  font: 700 clamp(3.6rem, 10vw, 10rem) ${theme.fonts.headings};
  text-align: center;
  color: transparent;
  background: url(${Logo2Lines}) center center/contain no-repeat;

  @media (orientation: portrait) {
    font-size: 12vw;
  }
`

export const Collage = styled(motion.img)`
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
`

export const Intro = styled.p`
  position: relative;
  font-size: 1.5rem;
  line-height: 1.6;
  text-align: center;
  max-width: 35em;
  margin: 0 auto;

  ${mq.medium} {
    margin: 6rem auto 13rem;
    font-size: 2rem;
    line-height: 1.5;
  }
`

export const Articles = styled.div`
  padding: min(15%, 18rem) 0 5rem;

  ${mq.medium} {
    padding-bottom: 0;
  }

  ${mq.smallOnly} {
    position: relative;
    overflow: hidden;

    &::after {
      ${Thread}
      top: 40vw;
      left: 0;
      margin: 0;
      width: 87%;
      height: 100%;
      mask-image: url("data:image/svg+xml,%3Csvg width='337' height='969' viewBox='0 0 337 969' fill='none' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cpath d='M-43.7627 63.8232C47.5842 -14.7887 218.008 -11.7389 272.034 26.391C326.06 64.5209 352.807 142.96 320.985 200.95C299.356 240.353 256.802 263.579 214.356 278.31C187.257 287.719 158.145 295.192 137.191 314.8C104.608 345.291 102.94 402.216 132.311 435.822C161.681 469.427 216.57 475.958 254.071 451.776C256.055 450.495 258.089 449.028 259.03 446.863C261.323 441.562 255.86 436.102 250.541 433.858C228.136 424.428 199.053 442.346 197.385 466.608C195.344 496.221 225.397 516.368 250.29 532.517C290.78 558.778 329.611 595.728 335.821 643.612C340.026 676.074 327.965 709.442 307.105 734.653C286.245 759.865 257.241 777.437 226.49 788.622C208.994 794.988 189.78 799.419 171.86 794.376C153.933 789.334 138.342 772.107 140.807 753.643C142.554 740.501 151.848 728.985 163.133 722.037C203.215 697.351 260.094 673.017 299.061 729.963C355.689 812.733 268.677 878.721 173.7 878.721C95.6512 878.721 16.5458 884.727 -30.9606 968.827' stroke='black' stroke-width='1.5' vector-effect='non-scaling-stroke' stroke-miterlimit='10'/%3E%3C/svg%3E");
      mask-size: 100% auto;
      mask-repeat: no-repeat;
      z-index: -1;
    }

    ${mq.extraSmall} {
      &::after {
        top: 50vw;
        width: 100%;
        mask-size: 112% auto;
      }
    }
  }

  > ${Container} {
    ${mq.smallOnly} {
      display: flex;
      flex-direction: column;
    }
  }
`

export const ShareContainer = styled.div`
  position: absolute;
  bottom: 3vw;
  left: 0;
  width: 100%;

  @media (orientation: portrait) {
    bottom: auto;
    top: 100vh;
    top: 100svh;
    margin-top: calc(-1 * var(--header-height) - 3rem);
    transform: translateY(-100%);
  }
`

export const ArrowDown = styled(IconShare).attrs({ isTextured: true })`
  display: block;
  margin: 5rem auto 0;
  font-size: 3rem;
  transform: rotateZ(90deg);
`
